import { useLanguage } from '../contexts/LanguageContext'

/**
 * Shown when a subscribed user hits monthly email/signed limits or template count (plan hard stop).
 */
export function UsageLimitSupportModal({ open, reason, onClose, onContactSupport }) {
  const { t } = useLanguage()
  if (!open) return null

  const title = t('usageLimit.modalTitle')

  let body
  if (reason === 'templates') {
    body = t('usageLimit.modalBodyTemplates')
  } else {
    body = t('usageLimit.modalBodyMonthly')
  }

  return (
    <div
      className="modal-backdrop send-confirm-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="usage-limit-support-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div className="modal send-confirm-modal modal--compact-branded" onClick={(e) => e.stopPropagation()}>
        <div className="account-modal__header modal__header--compact">
          <h3 className="modal__title" id="usage-limit-support-title">
            {title}
          </h3>
          <button type="button" className="account-modal__close ghost-button" aria-label={t('modal.close')} onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="modal__body--card-wrap">
          <div className="modal__card">
            <p className="modal__subtitle" style={{ margin: 0 }}>
              {body}
            </p>
          </div>
          <div className="modal__actions--below" style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            <button type="button" className="ghost-button" onClick={onClose}>
              {t('modal.ok')}
            </button>
            <button type="button" className="primary-button" onClick={onContactSupport}>
              {t('usageLimit.contactSupport')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
